import { useQuery } from 'react-query'
import { industryListRaw } from 'services/api'

export function useIndustryList(country: 'dk' | 'no' | 'se' | 'fi') {
  return useQuery(['industryList', country], () => industryListRaw(country), {
    retry: false,
    refetchOnWindowFocus: false,
  })
}
